var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-product__label pws-product-theme-tags-bg",style:({
    maxWidth: _vm.maxWidth ? (_vm.maxWidth + "px"): 'none'
  }),attrs:{"title":_vm.text}},[_c('span',{ref:"labelContent",staticClass:"plv-iar-product__label__content"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }